import {Injectable} from '@angular/core';
import {RouteLibraryParams} from './route-library-params';
import {RouteLibraryEntities, RouteLibraryEntity} from './route-library-entity';
import {RouteLibraryAction} from './route-library-action';


@Injectable({
  providedIn: 'root'
})
export class RouteLibraryService {
  public static readonly availableRoutes: Record<RouteLibraryEntity, Record<RouteLibraryAction, string>> = {
    [RouteLibraryEntities.UNIT]: {
      list: '/unit/unit-list',
      create: '/unit/unit-list/create',
      view: '/unit/unit-list/:id/view',
      update: '/unit/unit-list/:id/edit',
    },
    [RouteLibraryEntities.UNIT_TYPE]: {
      list: '/unit-type/unit-type-list',
      create: '/unit-type/unit-type-list/create',
      view: null,
      update: '/unit-type/unit-type-list/:id/edit',
    },
    [RouteLibraryEntities.CAR]: {
      list: '/unit/car-list',
      create: '/unit/car-list/create',
      view: '/unit/car-list/:id/view',
      update: '/unit/car-list/:id/edit',
    },
    [RouteLibraryEntities.BIKE]: {
      list: '/unit/bike-list',
      create: '/unit/bike-list/create',
      view: '/unit/bike-list/:id/view',
      update: '/unit/bike-list/:id/edit',
    },
    [RouteLibraryEntities.ELECTRIC_SCOOTER]: {
      list: '/unit/scooter-list',
      create: '/unit/scooter-list/create',
      view: '/unit/scooter-list/:id/view',
      update: '/unit/scooter-list/:id/edit',
    },
    [RouteLibraryEntities.ELECTRIC_BIKE]: {
      list: '/unit/electric-bike-list',
      create: '/unit/electric-bike-list/create',
      view: '/unit/electric-bike-list/:id/view',
      update: '/unit/electric-bike-list/:id/edit',
    },
    [RouteLibraryEntities.BABY_CARRIAGE]: {
      list: '/unit/baby-carriage-list',
      create: '/unit/baby-carriage-list/create',
      view: '/unit/baby-carriage-list/:id/view',
      update: '/unit/baby-carriage-list/:id/edit',
    },
    [RouteLibraryEntities.ELECTRIC_QUAD_BIKE]: {
      list: '/unit/electric-quad-bike-list',
      create: '/unit/electric-quad-bike-list/create',
      view: '/unit/electric-quad-bike-list/:id/view',
      update: '/unit/electric-quad-bike-list/:id/edit',
    },
    [RouteLibraryEntities.ELECTRIC_MOPED]: {
      list: '/unit/electric-moped-list',
      create: '/unit/electric-moped-list/create',
      view: '/unit/electric-moped-list/:id/view',
      update: '/unit/electric-moped-list/:id/edit',
    },
    [RouteLibraryEntities.BOAT]: {
      list: '/unit/boat-list',
      create: '/unit/boat-list/create',
      view: '/unit/boat-list/:id/view',
      update: '/unit/boat-list/:id/edit',
    },
    [RouteLibraryEntities.CHARGING]: {
      list: '/unit/charging-list',
      create: '/unit/charging-list/create',
      view: '/unit/charging-list/:id/view',
      update: '/unit/charging-list/:id/edit',
    },
    [RouteLibraryEntities.TRAILER]: {
      list: '/unit/trailer-list',
      create: '/unit/trailer-list/create',
      view: '/unit/trailer-list/:id/view',
      update: '/unit/trailer-list/:id/edit',
    },
    [RouteLibraryEntities.VELOMOBILE]: {
      list: '/unit/velomobile-list',
      create: '/unit/velomobile-list/create',
      view: '/unit/velomobile-list/:id/view',
      update: '/unit/velomobile-list/:id/edit',
    },
    [RouteLibraryEntities.TRICYCLE]: {
      list: '/unit/tricycle-list',
      create: '/unit/tricycle-list/create',
      view: '/unit/tricycle-list/:id/view',
      update: '/unit/tricycle-list/:id/edit',
    },
    [RouteLibraryEntities.TRACKER]: {
      list: '/unit/tracker-list',
      create: '/unit/tracker-list/create',
      view: '/unit/tracker-list/:id/view',
      update: '/unit/tracker-list/:id/edit',
    },
    [RouteLibraryEntities.IOT]: {
      list: '/unit/iot-list',
      create: '/unit/iot-list/create',
      view: '/unit/iot-list/:id/view',
      update: '/unit/iot-list/:id/edit',
    },
    [RouteLibraryEntities.TRIKE]: {
      list: '/unit/trike-list',
      create: '/unit/trike-list/create',
      view: '/unit/trike-list/:id/view',
      update: '/unit/trike-list/:id/edit',
    },
    [RouteLibraryEntities.ELECTRIC_SNOW_SCOOTER]: {
      list: '/unit/electric-snow-scooter-list',
      create: '/unit/electric-snow-scooter-list/create',
      view: '/unit/electric-snow-scooter-list/:id/view',
      update: '/unit/electric-snow-scooter-list/:id/edit',
    },
    [RouteLibraryEntities.MECHANICAL_BICYCLE_WITHOUT_IOT]: {
      list: '/unit/mechanical-bicycle-without-iot-list',
      create: '/unit/mechanical-bicycle-without-iot-list/create',
      view: '/unit/mechanical-bicycle-without-iot-list/:id/view',
      update: '/unit/mechanical-bicycle-without-iot-list/:id/edit',
    },
    [RouteLibraryEntities.ELECTRIC_BICYCLE_WITHOUT_IOT]: {
      list: '/unit/electric-bicycle-without-iot-list',
      create: '/unit/electric-bicycle-without-iot-list/create',
      view: '/unit/electric-bicycle-without-iot-list/:id/view',
      update: '/unit/electric-bicycle-without-iot-list/:id/edit',
    },
    [RouteLibraryEntities.ELECTRIC_BICYCLE_WITH_IOT]: {
      list: '/unit/electric-bicycle-with-iot-list',
      create: '/unit/electric-bicycle-with-iot-list/create',
      view: '/unit/electric-bicycle-with-iot-list/:id/view',
      update: '/unit/electric-bicycle-with-iot-list/:id/edit',
    },
    [RouteLibraryEntities.BATTERY]: {
      list: '/battery/battery-list',
      create: '/battery/battery-list/create',
      view: '/battery/battery-list/:id/view',
      update: '/battery/battery-list/:id/edit',
    },
    [RouteLibraryEntities.BUSINESS_LOGIC]: {
      list: '/business-logic',
      create: '/business-logic/create',
      view: null,
      update: '/business-logic/:id/edit',
    },
    [RouteLibraryEntities.PROJECT_END_USER_LEVEL]: {
      list: '/project/project-end-user-level',
      create: '/project/project-end-user-level/create',
      view: null,
      update: '/project/project-end-user-level/:id/edit',
    },
    [RouteLibraryEntities.PROJECT_END_USER_LEVEL_CONFIG]: {
      list: '/project/project-end-user-level-config',
      create: '/project/project-end-user-level-config/create',
      view: null,
      update: '/project/project-end-user-level-config/:id/edit',
    },
    [RouteLibraryEntities.UNIT_GROUP]: {
      list: '/unit/unit-group-list',
      create: '/unit/unit-group-list/create',
      view: null,
      update: '/unit/unit-group-list/:id/edit',
    },
    [RouteLibraryEntities.UNIT_MODEL]: {
      list: '/unit-model/unit-model-list',
      create: '/unit-model/unit-model-list/create',
      view: null,
      update: '/unit-model/unit-model-list/:id/edit',
    },
    [RouteLibraryEntities.UNIT_MODEL_GROUP]: {
      list: '/unit-model/unit-model-group-list',
      create: '/unit-model/unit-model-group-list/create',
      view: null,
      update: '/unit-model/unit-model-group-list/:id/edit',
    },
    [RouteLibraryEntities.UNIT_HW_MODEL]: {
      list: '/hardware/unit-hw-model',
      create: '/hardware/unit-hw-model/create',
      view: null,
      update: '/hardware/unit-hw-model/:id/edit',
    },
    [RouteLibraryEntities.UNIT_COMMAND_TEXT]: {
      list: '/hardware/command/unit-command-text',
      create: '/hardware/command/unit-command-text/create',
      view: null,
      update: '/hardware/command/unit-command-text/:id/edit',
    },
    [RouteLibraryEntities.COMMAND_DESCRIPTION]: {
      list: '/hardware/command/command-description',
      create: '/hardware/command/command-description/create',
      view: null,
      update: '/hardware/command/command-description/:id/edit',
    },
    [RouteLibraryEntities.REPEATER]: {
      list: '/hardware/repeater/repeater-list',
      create: '/hardware/repeater/repeater-list/create',
      view: '/hardware/repeater/repeater-list/:id/view',
      update: '/hardware/repeater/repeater-list/:id/update',
    },
    [RouteLibraryEntities.USER]: {
      list: '/user/user-list',
      create: '/user/user-list/create',
      view: '/user/user-list/:id/profile',
      update: '/user/user-list/:id/edit',
    },
    [RouteLibraryEntities.CUSTOM_ROLE]: {
      list: '/user/custom-role-list',
      create: '/user/custom-role-list/create',
      view: null,
      update: '/user/custom-role-list/:id/edit',
    },
    [RouteLibraryEntities.END_USER]: {
      list: '/end-user/end-user-list',
      create: '/end-user/end-user-list/create',
      view: '/end-user/end-user-list/:id/profile',
      update: '/end-user/end-user-list/:id/edit',
    },
    [RouteLibraryEntities.END_USER_ANONYMOUS]: {
      list: '/end-user-anonymous/end-user-list',
      create: null,
      view: '/end-user-anonymous/end-user-list/:id/profile',
      update: null,
    },
    [RouteLibraryEntities.COURIER]: {
      list: '/executor-courier/courier-list',
      create: '/executor-courier/courier-list/create',
      view: '/executor-courier/courier-list/:id/view',
      update: '/executor-courier/courier-list/:id/edit',
    },
    [RouteLibraryEntities.EMPLOYEE]: {
      list: null,
      create: null,
      view: '/employee/:id/view',
      update: null,
    },
    [RouteLibraryEntities.COURIER_EMPLOYEE]: {
      list: '/executor-courier/employee',
      create: '/executor-courier/employee/create-courier',
      view: '/executor-courier/employee/:id/view',
      update: '/executor-courier/employee/:id/registration',
    },
    [RouteLibraryEntities.COURIER_EMPLOYEE_GROUP]: {
      list: '/executor-courier/employee-group',
      create: '/executor-courier/employee-group/create',
      view: null,
      update: '/executor-courier/employee-group/:id/edit',
    },
    [RouteLibraryEntities.COURIER_EXTENDED_REGISTRATION_FORM]: {
      list: '/executor-courier/user-employee-extended-registration-form',
      create: '/executor-courier/user-employee-extended-registration-form/create',
      view: null,
      update: '/executor-courier/user-employee-extended-registration-form/:id/edit',
    },
    [RouteLibraryEntities.LEGAL_ENTITY]: {
      list: '/legal-entity',
      create: '/legal-entity/create',
      view: null,
      update: '/legal-entity/:id/edit',
    },
    [RouteLibraryEntities.BRANCH_OFFICE]: {
      list: '/branch-office',
      create: '/branch-office/create',
      view: '/branch-office/:id/view',
      update: '/branch-office/:id/edit',
    },
    [RouteLibraryEntities.BAG]: {
      list: '/bag/bag-list',
      create: '/bag/bag-list/create',
      view: null,
      update: '/bag/bag-list/:id/edit',
    },
    [RouteLibraryEntities.WORK_SHIFT]: {
      list: '/work-shift/work-shift-list',
      create: '/work-shift/work-shift-list/create',
      view: '/work-shift/work-shift-list/:id/view',
      update: '/work-shift/work-shift-list/:id/edit',
    },
    [RouteLibraryEntities.END_USER_GROUP]: {
      list: '/end-user/end-user-group',
      create: '/end-user/end-user-group/create',
      view: '/end-user/end-user-group/:id/view',
      update: '/end-user/end-user-group/:id/edit',
    },
    [RouteLibraryEntities.END_USER_ORDER]: {
      list: '/end-user-order/list',
      create: null,
      view: '/end-user-order/list/:id/view',
      update: null,
    },
    [RouteLibraryEntities.PREPAID_SHARING_ORDER]: {
      list: '/prepaid-sharing-order/list',
      create: null,
      view: '/prepaid-sharing-order/list/:id/view',
      update: null,
    },
    [RouteLibraryEntities.END_USER_PRICE_PLAN]: {
      list: '/end-user-price-plan/end-user-price-plan-list',
      create: '/end-user-price-plan/end-user-price-plan-list/create',
      view: '/end-user-price-plan/end-user-price-plan-list/:id/profile',
      update: '/end-user-price-plan/end-user-price-plan-list/:id/edit',
    },
    [RouteLibraryEntities.END_USER_PRICE_PLAN_SCHEDULE]: {
      list: '/end-user-price-plan/price-plan-schedule-list',
      create: '/end-user-price-plan/price-plan-schedule-list/create',
      view: '/end-user-price-plan/price-plan-schedule-list/:id/view',
      update: '/end-user-price-plan/price-plan-schedule-list/:id/edit',
    },
    [RouteLibraryEntities.SUBSCRIPTION]: {
      list: '/services/subscription-list',
      create: '/services/subscription-list/create',
      view: '/services/subscription-list/:id/profile',
      update: '/services/subscription-list/:id/edit',
    },
    [RouteLibraryEntities.SERVICE_REQUEST_NEW]: {
      list: '/service-request/new',
      create: '/service-request/new/create',
      view: null,
      update: '/service-request/new/:id/edit',
    },
    [RouteLibraryEntities.SERVICE_REQUEST_IN_PROGRESS]: {
      list: '/service-request/in-progress',
      create: '/service-request/in-progress/create',
      view: null,
      update: '/service-request/in-progress/:id/edit',
    },
    [RouteLibraryEntities.SERVICE_REQUEST_CLOSED]: {
      list: '/service-request/closed',
      create: '/service-request/closed/create',
      view: null,
      update: '/service-request/closed/:id/edit',
    },
    [RouteLibraryEntities.SUBSCRIPTION_PRICE_PLAN]: {
      list: '/end-user-price-plan/subscription-price-plan',
      create: '/end-user-price-plan/subscription-price-plan/create',
      view: '/end-user-price-plan/subscription-price-plan/:id/profile',
      update: '/end-user-price-plan/subscription-price-plan/:id/edit',
    },
    [RouteLibraryEntities.GEO_OBJECTS_GEOFENCE]: {
      list: '/geo-objects',
      create: '/geo-objects/geofence/create',
      view: '/geo-objects/geofence/:id/view',
      update: '/geo-objects/geofence/:id/edit',
    },
    [RouteLibraryEntities.GEO_OBJECTS_GEOPOINT]: {
      list: '/geo-objects',
      create: '/geo-objects/geopoint/create',
      view: '/geo-objects/geopoint/:id/view',
      update: '/geo-objects/geopoint/:id/edit',
    },
    [RouteLibraryEntities.GEO_OBJECTS_GEOPOINT_TYPE]: {
      list: '/geo-objects',
      create: '/geo-objects/geopoint-type/create',
      view: null,
      update: '/geo-objects/geopoint-type/:id/edit',
    },
    [RouteLibraryEntities.GEO_OBJECTS_WEEKLY_SCHEDULE]: {
      list: '/geo-objects',
      create: '/geo-objects/weekly-schedule/create',
      view: '/geo-objects/weekly-schedule/:id/view',
      update: '/geo-objects/weekly-schedule/:id/edit',
    },
    [RouteLibraryEntities.PROJECT]: {
      list: 'project/list',
      create: '/project/create',
      view: null,
      update: '/project/:id/edit',
    },
    [RouteLibraryEntities.PROJECT_COUNTRY]: {
      list: '/project/project-country',
      create: '/project/project-country/create',
      view: null,
      update: '/project/project-country/:id/edit',
    },
    [RouteLibraryEntities.PAYMENT_SERVICE]: {
      list: '/project/payment-service',
      create: '/project/payment-service/create',
      view: null,
      update: '/project/payment-service/:id/edit',
    },
    [RouteLibraryEntities.ACQUIRER]: {
      list: '/project/acquirer',
      create: '/project/acquirer/create',
      view: null,
      update: '/project/acquirer/:id/edit',
    },
    [RouteLibraryEntities.GEO_OBJECTS_REGION]: {
      list: '/geo-objects',
      create: '/geo-objects/region/create',
      view: '/geo-objects/region/:id/view',
      update: '/geo-objects/region/:id/edit',
    },
    [RouteLibraryEntities.INSURANCE_PROVIDER]: {
      list: '/project/insurance-provider/insurance-providers',
      create: '/project/insurance-provider/insurance-providers/create',
      view: '/project/insurance-provider/insurance-providers/:id/report-log',
      update: '/project/insurance-provider/insurance-providers/:id/edit',
    },
    [RouteLibraryEntities.SMS_GATEWAY]: {
      list: '/project/sms-gateway',
      create: '/project/sms-gateway/create',
      view: null,
      update: '/project/sms-gateway/:id/edit',
    },
    [RouteLibraryEntities.SUPPORT_CONTACT]: {
      list: '/project/support-contact',
      create: '/project/support-contact/create',
      view: null,
      update: '/project/support-contact/:id/edit',
    },
    [RouteLibraryEntities.ACCEPTANCE_CERTIFICATE]: {
      list: '/project/acceptance-certificate',
      create: '/project/acceptance-certificate/create',
      view: null,
      update: '/project/acceptance-certificate/:id/edit',
    },
    [RouteLibraryEntities.LEGAL_DOCUMENTS]: {
      list: '/project/legal-documents',
      create: '/project/legal-documents/create',
      view: null,
      update: '/project/legal-documents/:id/edit',
    },
    [RouteLibraryEntities.DOCUMENT]: {
      list: '/project/document',
      create: '/project/document/create',
      view: null,
      update: '/project/document/:id/edit',
    },
    [RouteLibraryEntities.NOTIFICATION]: {
      list: '/notification/notification-list',
      create: '/notification/notification-list/create',
      view: '/notification/notification-list/:id/view',
      update: '/notification/notification-list/:id/edit',
    },
    [RouteLibraryEntities.END_USER_NOTIFICATION]: {
      list: '/notification/end-user-notification-list',
      create: '/notification/end-user-notification-list/create',
      view: '/notification/end-user-notification-list/:id/view',
      update: '/notification/end-user-notification-list/:id/edit',
    },
    [RouteLibraryEntities.PROMOTION_AND_NEWS]: {
      list: '/promotions-and-news/promotions-and-news-list',
      create: '/promotions-and-news/promotions-and-news-list/create',
      view: '/promotions-and-news/promotions-and-news-list/:id/view',
      update: '/promotions-and-news/promotions-and-news-list/:id/edit',
    },
    [RouteLibraryEntities.UNIT_LOG]: {
      list: '/notification/unit-log-list',
      create: null,
      view: '/notification/unit-log-list/:id/view',
      update: '/notification/unit-log-list/:id/view',
    },
    [RouteLibraryEntities.END_USER_LOG]: {
      list: '/notification/unit-log-list',
      create: null,
      view: '/notification/end-user-log-list/:id/view',
      update: '/notification/end-user-log-list/:id/view',
    },
    [RouteLibraryEntities.TOURIST_ROUTE]: {
      list: '/services/tourist-route-list',
      create: null,
      view: '/services/tourist-route-list/:id/view',
      update: '/services/tourist-route-list/:id/edit',
    },
    [RouteLibraryEntities.TOURIST_ROUTE_POINT]: {
      list: null,
      create: null,
      view: null,
      update: '/services/tourist-route-list/route-point/:id/edit',
    },
    [RouteLibraryEntities.PROMO_CODE]: {
      list: '/promo-code/list',
      create: '/promo-code/list/create',
      view: null,
      update: '/promo-code/list/:id/edit',
    },
    [RouteLibraryEntities.BALANCE_PACKAGE]: {
      list: '/services/balance-package-list',
      create: '/services/balance-package-list/create',
      view: null,
      update: '/services/balance-package-list/:id/edit',
    },
    [RouteLibraryEntities.BALANCE_PACKAGE_PURCHASE]: {
      list: 'purchases/balance-package-purchase-list',
      create: null,
      view: null,
      update: null,
    },
    [RouteLibraryEntities.TOURIST_ROUTE_PURCHASE]: {
      list: 'purchases/tourist-route-purchase-list',
      create: null,
      view: 'purchases/tourist-route-purchase-list/:id/transaction-list',
      update: null,
    },
    [RouteLibraryEntities.COMMODITY]: {
      list: '/services/commodity-list',
      create: '/services/commodity-list/create',
      view: '/services/commodity-list/:id/view',
      update: '/services/commodity-list/:id/edit',
    },
    [RouteLibraryEntities.COMMODITY_PURCHASE]: {
      list: '/purchases/commodity-purchase-list',
      create: '/purchases/commodity-purchase-list/create',
      view: '/purchases/commodity-purchase-list/:id/view',
      update: null,
    },
    [RouteLibraryEntities.EXECUTOR_PRICE_PLAN]: {
      list: '/executor-price-plan/executor-price-plan-list',
      create: '/executor-price-plan/executor-price-plan-list/create',
      view: '/executor-price-plan/executor-price-plan-list/:id/view',
      update: '/executor-price-plan/executor-price-plan-list/:id/edit',
    },
    [RouteLibraryEntities.PREPAID_SHARING_PRICE_PLAN]: {
      list: '/prepaid-sharing-price-plan/prepaid-sharing-price-plan-list',
      create: '/prepaid-sharing-price-plan/prepaid-sharing-price-plan-list/create',
      view: '/prepaid-sharing-price-plan/prepaid-sharing-price-plan-list/:id/view',
      update: '/prepaid-sharing-price-plan/prepaid-sharing-price-plan-list/:id/edit',
    },
    [RouteLibraryEntities.EXECUTOR_PRICE_PLAN_GROUP]: {
      list: '/executor-price-plan/executor-price-plan-group-list',
      create: '/executor-price-plan/executor-price-plan-group-list/create',
      view: '/executor-price-plan/executor-price-plan-group-list/:id/view',
      update: '/executor-price-plan/executor-price-plan-group-list/:id/edit',
    },
    [RouteLibraryEntities.EXECUTOR_BILLING_LONG_TERM]: {
      list: '/executor-courier/executor-billing-long-term',
      create: '/executor-courier/executor-billing-long-term/create',
      view: '/executor-courier/executor-billing-long-term/:id/view',
      update: '/executor-courier/executor-billing-long-term/:id/edit',
    },
    [RouteLibraryEntities.FINANCIAL_OPERATION]: {
      list: '/end-user/financial-operations/list',
      create: null,
      view: '/end-user/financial-operations/list/:id/view',
      update: null,
    },
    [RouteLibraryEntities.EXECUTOR_FINANCIAL_OPERATION]: {
      list: '/executor-courier/executor-financial-operation/list',
      create: null,
      view: '/executor-courier/executor-financial-operation/list/:id/view',
      update: null,
    },
    [RouteLibraryEntities.COMPONENT_TYPE]: {
      list: '/component-type',
      create: null,
      view: null,
      update: '/component-type/:id/edit',
    },
    [RouteLibraryEntities.COMPONENT_MODEL]: {
      list: '/component-model',
      create: null,
      view: '/component-model/:id/view',
      update: '/component-model/:id/edit',
    },
    [RouteLibraryEntities.COMPONENT]: {
      list: '/component',
      create: '/component/:id/create',
      view: '/component/:id/view',
      update: '/component/:id/edit',
    },
    [RouteLibraryEntities.COMPONENT_WITHOUT_SN]: {
      list: '/component-without-sn',
      create: '/component-without-sn/:id/create',
      view: '/component-without-sn/:id/view',
      update: '/component-without-sn/:id/edit',
    },
    [RouteLibraryEntities.WAREHOUSE]: {
      list: '/warehouse',
      create: null,
      view: '/warehouse/:id/view',
      update: null,
    },
    [RouteLibraryEntities.CUSTOMIZATION]: {
      list: '/diagnostics/customization',
      create: '/diagnostics/customization/:id/create',
      view: null,
      update: '/diagnostics/customization/:id/edit',
    },
  };

  constructor() {
  }

  routeHasAction(entity: RouteLibraryEntity, action: RouteLibraryAction) {
    return RouteLibraryService.availableRoutes[entity]
      && RouteLibraryService.availableRoutes[entity][action];
  }

  public getRoute(params: RouteLibraryParams) {
    if (this.routeHasAction(params.entity, params.action)) {
      const route = RouteLibraryService.availableRoutes[params.entity][params.action];
      return params.id ? route.replace(':id', params.id.toString()) : route;
    } else {
      return null;
    }
  }
}
